import { observer } from 'mobx-react-lite';
import type { ShiritoriGameStore } from '@/game/core/game.store';
import { SpinLoader } from '@/components/loader/spin-loader';
import { ShiritoriBoard } from '@/components/board/shiritori-board';
import { SpectatePanel } from '@/components/board/spectate-panel';
import { EndGameModal } from '@/components/board/end-game-modal';

interface SpectateProps {
    game: ShiritoriGameStore;
}

export const Spectate = observer(function ({ game }: SpectateProps) {
    if (!game.hasData) {
        return (
            <div className="w-full h-full flex items-center justify-center">
                <SpinLoader className="w-8 h-8" />
            </div>
        );
    }

    return (
        <div className="min-h-full w-full">
            <div className="mx-auto max-w-6xl px-4 py-6">
                <div className="grid gap-6 items-start lg:grid-cols-[1.15fr,0.85fr]">
                    <ShiritoriBoard game={game} />
                    <SpectatePanel game={game} />
                </div>
            </div>
            <EndGameModal game={game} />
        </div>
    );
});
